import { createFileRoute } from "@tanstack/react-router";
import { ProductsPricing } from "@/components/ProductsPricing";
import { redirect } from "@/lib/navigation";

function RouteComponent() {
  try {
    return <ProductsPricing />;
  } catch (error) {
    console.error("Products & Pricing page error:", error);
    redirect("/");
  }
}

export const Route = createFileRoute("/_authenticated/products-pricing/")({
  component: RouteComponent,
  staticData: { page: "finance" },
});
